import { render } from "./DlcView.vue?vue&type=template&id=111540ca&scoped=true"
import script from "./DlcView.vue?vue&type=script&lang=js"
export * from "./DlcView.vue?vue&type=script&lang=js"

import "./DlcView.vue?vue&type=style&index=0&id=111540ca&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111540ca"]])

export default __exports__